import styled from 'styled-components';

import {
  SVG,
} from 'web-styled';

export const PlusCircle = styled(SVG.PlusCircle).attrs(
  props => ({
    width: 14,
    height: 14,
    stroke: props.theme.colors.primary,
  }),
)`
`;
